import { AbstractControl } from '@angular/forms';
import { inDepth } from './in-depth';

export const validateInDepth = <T>(control: AbstractControl<T>): boolean => {
  inDepth(control, (control) => {
    control.markAsTouched();
    control.markAsDirty();
  });

  return control.valid;
};
